// Хранение настроек в cookie.
//
// Cookie, а не localStorage, — сознательный выбор с одной оговоркой: они
// уезжают на сервер с каждым запросом, включая рукопожатие WebSocket. Для
// пары сотен байт настроек это несущественно, а взамен они переживают
// смену порта (localStorage привязан к origin вместе с портом, cookie — нет)
// и живут по общим правилам домена.
//
// Секреты сюда не кладём: то, что уходит на сервер автоматически, попадает и
// в логи обратного прокси, если тот когда-нибудь начнёт писать заголовки.
// Токен остаётся в localStorage.

/** Год. Настройки подбирают один раз и больше к ним не возвращаются. */
const MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

/**
 * Записать значение.
 *
 * `Secure` ставится только на https: на `http://localhost` браузер такую
 * cookie молча отбрасывает, и отладочный режим потерял бы все настройки.
 */
export function write(name: string, value: string): void {
  const parts = [
    `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
    "path=/",
    `max-age=${MAX_AGE_SECONDS}`,
    "SameSite=Lax",
  ];
  if (location.protocol === "https:") {
    parts.push("Secure");
  }

  try {
    document.cookie = parts.join("; ");
  } catch {
    // В приватном окне или при запрещённых cookie запись бросает. Настройки —
    // удобство, а не условие работы: молча продолжаем с умолчаниями.
  }
}

export function read(name: string): string | null {
  const prefix = `${encodeURIComponent(name)}=`;

  for (const chunk of document.cookie.split(";")) {
    const entry = chunk.trim();
    if (entry.startsWith(prefix)) {
      try {
        return decodeURIComponent(entry.slice(prefix.length));
      } catch {
        // Испорченное значение — то же самое, что его отсутствие.
        return null;
      }
    }
  }
  return null;
}

export function remove(name: string): void {
  document.cookie = `${encodeURIComponent(name)}=; path=/; max-age=0; SameSite=Lax`;
}

/**
 * Перенести значение из localStorage, если оно там осталось от прошлых версий.
 *
 * Разовая операция: после переноса запись из localStorage удаляется, и дальше
 * работает только cookie.
 */
export function migrate(name: string): void {
  if (read(name) !== null) {
    return;
  }
  const legacy = localStorage.getItem(name);
  if (legacy !== null) {
    write(name, legacy);
    localStorage.removeItem(name);
  }
}
